module.exports = __webpack_public_path__ + "static/media/sag.d773d798.jpg";